import * as React from 'react';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import {
    createStyles,
    makeStyles,
} from '@material-ui/core';

import { FeedbackForm, PageLayout } from '../../common/components';
import { getBreadCrumb } from '../../common/breadcrumbUtil';

const useStyles = makeStyles(() => createStyles({
    main: {
    },
}));

const Feedback = () => {
    const classes = useStyles();
    const translate = useSelector(state => getTranslate(state.localize));
    const clientConfig = useSelector(state => state.auth.clientConfig);

    return (
        <PageLayout
            // title={translate('feedback.feedback')}
            breadcrumb={getBreadCrumb(translate('feedback.feedback'), translate, clientConfig)}
        >
            <div className={classes.main}>
                <FeedbackForm />
            </div>
        </PageLayout>
    );
};

export default Feedback;
